import React from 'react';
const Skeleton = () => {
  return <div className={'skeleton-section smartforms-techtarget'} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx">
   <div className={'skeleton-loading'}>
    <div className={'skeleton-title'}></div>
    <div className={'skeleton-description'}></div>
    <div className={'skeleton-description'}></div>
    <div className={'buttons-skeleton'}></div>
   </div>
  </div>;
};
export default Skeleton;